<template lang="pug">
div
  .asu-title.div-aux-to-fixed-header
    span.asu-title Cotas
  section.control-year.isMap.control-panel-box
    div.years-labels
      template(v-for="(cota, index) in cotaNumberList")
        span(:key="`cota-year-label-${cota}`")
          div {{cota}}
          div.mts ({{cotaByMtsObj[cota]}})
        span(:key="`cota-year-separator-${cota}`" v-if="(index + 1) < cotaNumberList.length")

    div
      template(v-for="(cota, index) in cotaNumberList")
        i.clickable(:key="`cota-clickable-${cota}`" :class="'ap-timeline' + (currentCota === cota ? '-selected':'')" @click="setCotaAndStopEventPropagations($event, cota)")
        .timeline-separator(:key="`cota-timeline-separator-${cota}`" v-if="(index + 1) < cotaNumberList.length")

    div.geojson-file
      span Archivo de georeferencia de Cotas
      DownloadButton(href="https://drive.google.com/open?id=1FvkOjkXGD6olFA6RIFcpONwu64pQRKFD")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { cotaNumberList, cotaByMtsObj } from '@/constants.js'

export default {
  data: () => ({
    cotaNumberList,
    cotaByMtsObj
  }),
  methods: {
    ...mapActions([
      'setCurrentCota',
      'toggle'
    ]),
    setCotaAndStopEventPropagations (event, cota) {
      if (this.currentCota === cota) {
        this.setCurrentCota(0)
      } else {
        this.setCurrentCota(cota)
      }
      event.stopPropagation()
    }
  },
  computed: {
    ...mapGetters([
      'data',
      'currentCota',
      'showYearLengends'
    ])
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

$filter-year-pointer-size = $f35px
$filter-year-pointer-color = #0d2563
$filter-year-pointer-arrow-size = $f10px
$filter-year-pointer-separator = $filter-year-pointer-size

$filter-year-pointer-size-in-mobile = $f25px
$filter-year-pointer-separator-in-mobile = $filter-year-pointer-size-in-mobile

.isMobile
  .control-year
    transform: scale(0.7)
  .legends
    display: none
  .show-legends
    display: block
  .asu-title
    margin-left: 10px

.control-year
  user-select none
  text-align: center
  color: $filter-year-pointer-color
  background-color: white
  border-radius: $f4px
  overflow-y: auto
  min-height: $f172px
  .asu-title
    padding: 0 $title-padding 0 $title-padding
  span
    display inline-block
  .years-labels
    margin-bottom: $f5px
    span
      color: $gray_color
      font-size: 1.2rem
      font-weight: bold
      text-shadow: 0.0625rem 0.0625rem 0.3125rem #fff, -1px -1px 0.3125rem #fff
      width: $filter-year-pointer-size
      & .mts
        font-size: $f12px
  .clickable
    cursor: pointer
    display: inline-block
    font-size: $filter-year-pointer-size
    vertical-align: middle
    text-shadow: 0.0625rem 0.0625rem 0.3125rem #fff, -1px -1px 0.3125rem #fff
  .timeline-separator
    display: inline-block
    width: $filter-year-pointer-separator
    &:before,
    &:after
      content: ''
      background-color: $filter-year-pointer-color
      border-radius: 50%
      display: inline-block
      width: "calc(%s * .15)" % $filter-year-pointer-size
      height: "calc(%s * .15)" % $filter-year-pointer-size
    &:before
      margin-right: "calc(%s * .20)" % $filter-year-pointer-size
    &:after
      margin-left: "calc(%s * .20)" % $filter-year-pointer-size
  @media screen and (max-width: 768px)
    margin-left: 0
    min-height: $f131px
    .years-labels span
      width: "calc(%s + 5px)" % $filter-year-pointer-size-in-mobile
    .timeline-separator
      width: $filter-year-pointer-separator-in-mobile
      &:before,
      &:after
        width: "calc(%s * .15)" % $filter-year-pointer-size-in-mobile
        height: "calc(%s * .15)" % $filter-year-pointer-size-in-mobile
      &:before
        margin-right: "calc(%s * .20)" % $filter-year-pointer-size-in-mobile
      &:after
        margin-left: "calc(%s * .20)" % $filter-year-pointer-size-in-mobile

  .geojson-file
    display: flex
    margin-top: $f10px
    align-items: center
    justify-content: space-around

</style>
